import { CheckCircleOutline, DoDisturbOn, Download } from "@mui/icons-material";
import {
    Alert,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import {
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    documentReset,
    GetAllEverSignDocuments,
} from "../../Redux/EverSignDocumentsSlice/EverSignDocumentsSlice";

function AllDocuments() {
    const dispatch = useDispatch();
    const { is_completed } = useParams();
    const { documents, isLoading, isSuccess, isError } = useSelector(
        (state) => state.eversign_documents
    );
    const eversign_documents = documents?.data?.data || [];
    console.log(eversign_documents)
    console.log(eversign_documents?.solutionable?.estimated_cost.reduce((a,b) => a + b , 0))
    const documentsPag = documents?.data || [];

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        const callSearchAction = async () => {
            await dispatch(
                GetAllEverSignDocuments({
                    is_completed: is_completed,
                    paginate: rowsPerPage,
                    page: newPage + 1,
                })
            );
            await dispatch(documentReset());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            await dispatch(
                GetAllEverSignDocuments({
                    is_completed: is_completed,
                    paginate: event.target.value,
                })
            );
            await dispatch(documentReset());
        };
        callSearchAction();
    };

    useEffect(() => {
        console.log(is_completed);
        const GetAllEverSignDocumentAction = async () => {
            if (is_completed)
                await dispatch(
                    GetAllEverSignDocuments({ is_completed: is_completed })
                );
            else
                await dispatch(
                    GetAllEverSignDocuments({ is_completed: is_completed })
                );
            await dispatch(documentReset());
        };
        GetAllEverSignDocumentAction();
    }, [dispatch, is_completed]);

    const handelDownloadPdfFile = (e, path) => {
        const link = document.createElement("a");
        
        link.download = `${path}`;
        link.href = path;
        link.click();
    }

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <TableContainerStyled>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>User Name</TableCell>
                                <TableCell>User Email</TableCell>
                                <TableCell>Lead Name</TableCell>
                                <TableCell>Lead Email</TableCell>
                                <TableCell>Lead Phone </TableCell>
                                <TableCell>Solution Cost </TableCell>
                                <TableCell>User Childrens </TableCell>
                                <TableCell>Is Completed </TableCell>
                                <TableCell>Actions </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {eversign_documents?.map((key, index) => (
                                <TableRowStyled key={key?.id}>
                                    <TableCellStyle>
                                        {rowsPerPage * page + index + 1}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.solutionable?.user?.name}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.solutionable?.user?.email}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.solutionable?.lead?.first_name +
                                            key?.solutionable?.lead?.last_name}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.solutionable?.lead?.email}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.solutionable?.lead?.phone}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.solutionable?.estimated_cost}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {
                                            key?.solutionable?.user?.children
                                                .length
                                        }
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        {key.is_completed !== 0 ? (
                                            <CheckCircleOutline color="primary" />
                                        ) : (
                                            <DoDisturbOn />
                                        )}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        <IconButton onClick={(e) => handelDownloadPdfFile(e, key?.solutionable?.pdf_path)} sx={{color: "green"}}>
                                                <Download />
                                        </IconButton>
                                    </TableCellStyle>
                                    
                                </TableRowStyled>
                            ))}
                        </TableBody>

                        <TableHeadStyled>
                            <TableRow>
                                {documentsPag.total >= 20 && (
                                    <TablePagination
                                        rowsPerPageOptions={[
                                            20,
                                            50,
                                            100,
                                            { label: "All", value: -1 },
                                        ]}
                                        colSpan={12}
                                        count={documentsPag.total}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={
                                            handleChangeRowsPerPage
                                        }
                                    />
                                )}
                            </TableRow>
                        </TableHeadStyled>
                    </Table>

                    {documentsPag?.total < 1 && (
                        <Alert icon={false} severity="error">
                            <Typography
                                variant="h6"
                                className="MuiTypography-alignCenter"
                            >
                                There are no items, please try again
                            </Typography>
                        </Alert>
                    )}
                </TableContainerStyled>
            )}
        </>
    );
}

export default AllDocuments;
